import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import Seo from "@/components/Seo";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#F7F5F0]" data-testid="privacy-page">
      <Seo
        title="Privacy Policy"
        description="How CareHomeConnect collects, uses, and protects your information."
        path="/privacy"
      />
      <PublicNav />
      <section className="max-w-3xl mx-auto px-6 md:px-12 pt-12 md:pt-20 pb-8">
        <div className="text-sm text-[#9CAF88] font-semibold mb-3 uppercase tracking-wider">Legal</div>
        <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#1A2E24] tracking-tight">
          Privacy Policy
        </h1>
        <p className="mt-5 text-sm text-[#5C6B62]">Last updated: February 2026</p>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 pb-20 text-[#1A2E24] text-base leading-relaxed space-y-6">
        <p>
          CareHomeConnect (&quot;we&quot;, &quot;our&quot;, &quot;us&quot;) helps families find the right senior
          care. We take your privacy seriously. This policy explains what we collect, how we use it,
          and the choices you have.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">What we collect</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Information you give us:</strong> name, email, phone number, zip code, quiz answers, and any details you choose to share.</li>
          <li><strong>Automatic data:</strong> device info, IP address, pages viewed, and referring source (including UTM parameters).</li>
          <li><strong>Cookies:</strong> small files used to keep you signed in, remember your progress, and measure how our content performs.</li>
        </ul>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">How we use it</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li>To deliver personalized care recommendations based on your quiz answers.</li>
          <li>To send your results and follow-up guidance by email and, if you opt in, SMS.</li>
          <li>To connect you with vetted senior care partners that match your needs and location.</li>
          <li>To improve our articles, quiz, and overall experience.</li>
        </ul>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Who we share it with</h2>
        <p>
          We share your contact details and care preferences only with the senior living community
          or placement specialist you&apos;ve been matched with. We do not sell your information to
          third parties. We use trusted service providers (email, SMS, hosting, analytics) strictly
          to operate the service.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Your choices</h2>
        <ul className="list-disc pl-6 space-y-2">
          <li><strong>Unsubscribe</strong> from emails at any time using the link in every message.</li>
          <li><strong>Stop SMS</strong> by replying STOP to any text we send.</li>
          <li><strong>Access, correct, or delete</strong> your data by emailing <a className="text-[#2C4C3B] underline" href="mailto:privacy@carehomeconnect.com">privacy@carehomeconnect.com</a>.</li>
          <li><strong>Do Not Sell/Share</strong> (CA residents): we do not sell your data; you can still submit a verifiable request via the email above.</li>
        </ul>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">How we protect it</h2>
        <p>
          We use encryption in transit (TLS), access controls, and secure cloud infrastructure. No
          system is 100% secure, but we work hard to keep your information safe and only keep it as
          long as needed to serve you.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Children</h2>
        <p>
          CareHomeConnect is not directed to children under 13. We do not knowingly collect
          information from children.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Changes</h2>
        <p>
          We may update this policy from time to time. When we make material changes, we&apos;ll
          update the date above and, where appropriate, notify you by email.
        </p>

        <h2 className="font-display text-2xl font-semibold text-[#1A2E24] mt-10">Contact</h2>
        <p>
          Questions? Email <a className="text-[#2C4C3B] underline" href="mailto:privacy@carehomeconnect.com">privacy@carehomeconnect.com</a>.
        </p>
      </section>
      <PublicFooter />
    </div>
  );
}
